/**
 * Nested data grid component
 */

import React from 'react';
import { SimpleDataGrid_formatRow, DDLabel } from "../../common/components.jsx";
import { DownloadTableAsShownXLSX          } from "../DownloadTableAsShownXLSX.js";
import 'regenerator-runtime/runtime';
import './nested-data-grid.css';

export class NestedDataGrid extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      filterStr: this.props.filterStr ? this.props.filterStr : '',
      doUpdate: this.props.doUpdate,
    };
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleDowloadAsShown = this.handleDowloadAsShown.bind(this);
    this.getInnerText = this.getInnerText.bind(this);
    this.downloadTableAsShown = this.downloadTableAsShown.bind(this);
    this.rowToggleHandler = this.rowToggleHandler.bind(this);
    this.generateChildRow = this.generateChildRow.bind(this);

    this.gridRef = React.createRef();
  };

  rowToggleHandler(e) {
    console.log(e);
    const currentEl = e.currentTarget;
    const currentTr = currentEl.parentElement;
    const nextRow = currentTr.nextSibling;
    if (nextRow.className.indexOf('row-collapsed') < 0) {
      nextRow.classList.add('row-collapsed');
      currentTr.classList.add('state-collapsed');
    } else {
      nextRow.classList.remove('row-collapsed');
      currentTr.classList.remove('state-collapsed');
    }
  }

  getInnerText(el) {
    if (typeof el == "string") return el;
    if (typeof el == "undefined") { return el };
    if (el.innerText) return el.innerText;  //Not needed but it is faster
    var str = "";

    var cs = el.childNodes;
    var l = cs.length;
    for (var i = 0; i < l; i++) {
      switch (cs[i].nodeType) {
        case 1: // ELEMENT_NODE
          str += this.getInnerText(cs[i]);
          if (str == '' && cs[i].childNodes.length == 0) {
            if (cs[i].nodeName == 'IMG') {
              if (cs[i].getAttribute('label')) {
                str = cs[i].getAttribute('label');
              }
            }
          }
          break;
        case 3: // TEXT_NODE
          str += cs[i].nodeValue;
          break;
      }
    }
    return str;
  }

  downloadTableAsShown(table) {
    var fileName = 'drilldown.xls';
    if (this.props.downloadName) {
      fileName = this.props.downloadName + '.xls';
    }
    var a = document.createElement('a');
    var mimeType = '"application/vnd.ms-excel';
    var content = "<!DOCTYPE html><html><head><meta  http-equiv=\"Content-type\" content=\"text/html;  charset=UTF-8\">"
      + '<!--\[if gte mso 9\]>'
      + '<xml>'
      + '<x:ExcelWorkbook>'
      + '<x:ExcelWorksheets>'
      + '<x:ExcelWorksheet>'
      + '<x:Name>drilldown-31</x:Name>'
      + '<x:WorksheetOptions>'
      + '<x:Selected/>'
      + '<x:DoNotDisplayGridlines/>'
      + '<x:FreezePanes/>'
      + '<x:FrozenNoSplit/>'
      + '<x:SplitHorizontal>2</x:SplitHorizontal>'
      + '<x:TopRowBottomPane>2</x:TopRowBottomPane>'
      + '<x:ProtectContents>False</x:ProtectContents>'
      + '<x:ProtectObjects>False</x:ProtectObjects>'
      + '<x:ProtectScenarios>False</x:ProtectScenarios>'
      + '</x:WorksheetOptions>'
      + '</x:ExcelWorksheet>'
      + '</x:ExcelWorksheets>'
      + '</x:ExcelWorkbook>'
      + '</xml>'
      + '<!\[endif\]-->'
      + "</head><body><table border=1 bordercolor='#eeeeee'><tr>";

    var firstHdrTD = table.querySelector('thead tr:first-child th');

    var tr = firstHdrTD.parentNode;
    var el = firstHdrTD;
    while (el) {
      // console.log(el.nodeType);
      if (el.nodeType == 1) {
        var txt = this.getInnerText(el);
        console.log(txt);
        content += "<td  filter=all style='background-color: #0096d6; color: white'>" + txt + "</td>"
      }
      el = el.nextSibling;
    }
    content += "</tr>"
    //console.log(content);
    tr = table.querySelector('tbody tr:first-child');
    // tr.nextSibling;
    var row = 0;
    while (tr) {
      console.log(tr.nodeType);
      if (tr.nodeType == 1) {
        row = row + 1;
        var txt = this.getInnerText(tr);
        content += "<tr>"
        var td = tr.firstChild;
        while (td) {
          if (td.nodeType == 1) {
            var txt = this.getInnerText(td)
            content += "<td style='mso-number-format:\"\@\"; '>" + txt + "</td>"
          }
          td = td.nextSibling;
        }
        content += "</tr>"
      }
      tr = tr.nextSibling;
    }
    content += "</table></body></html>"
    //console.log('download data length:', content.length);

    if (navigator.msSaveBlob) { // IE10
      return navigator.msSaveBlob(new Blob([content], { type: mimeType }), fileName);
    } else if ('download' in a) { //html5 A[download]
      //console.log('via download attribute');
      if (content.length > 1333000) {
        console.log('large --> try blob ...');
        var blob = new Blob([content], { type: mimeType }); //
        var url = URL.createObjectURL(blob);
        a.href = url;
        setTimeout(function () {
          window.URL.revokeObjectURL(url);
        }, 3000);
      } else {
        a.href = 'data:' + mimeType + ',' + encodeURIComponent(content);
      }
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return true;
    } else { //do iframe dataURL download (old ch+FF):
      var f = document.createElement('iframe');
      document.body.appendChild(f);
      f.src = 'data:' + mimeType + ',' + encodeURIComponent(content);

      setTimeout(function () {
        document.body.removeChild(f);
      }, 333);
      return true;
    }
  }

  handleDowloadAsShown() {
    var c = this.gridRef.current;
    var t = c.querySelectorAll(".grid-container-table")[0];
    DownloadTableAsShownXLSX ( t, this.props.downloadName, true );
  }

  adjustHeader(c, invokes) {

    if (invokes === undefined) invokes = 0;
    //console.log("adjustHeader: invokes=",invokes);
    var frozenDiv = c.querySelectorAll(".frozen-grid-header")[0];
    if (frozenDiv.hasChildNodes()) {
      if (invokes == -1) {
        while (frozenDiv.firstChild) {
          frozenDiv.removeChild(frozenDiv.lastChild);
        }
      } else {
        // already created the second table header
        return;
      }
    }

    var t = c.querySelectorAll(".grid-container-table")[0];
    var head = t.querySelectorAll("thead")[0];
    var nt = document.createElement("table");
    nt.className = t.className;
    nt.classList.remove("grid-container-table");
    nt.style["margin-bottom"] = '0px';
    //nt.classList.add("table");
    //nt.classList.add("table-hover");
    nt.appendChild(head.cloneNode(true));

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    var el = head.querySelectorAll("tr th");
    var hel = nt.querySelectorAll("tr th");

    //console.log("adjustHeader:", el, hel);

    var hasAuto = 0;
    for (var i = 0; i < el.length; i++) {
      //console.log('width: el ', i, el[i].offsetWidth, getComputedStyle(el[i]).width );
      var w = getComputedStyle(el[i]).width;
      if (w == "auto") {
        hasAuto = 1;
        break;
      }
      if (isIE11) {
        var w_no = Math.round(parseFloat(w));
        hel[i].style["min-width"] = (w_no + 9) + 'px';
        hel[i].style["max-width"] = (w_no + 9) + 'px';
      } else {
        hel[i].style["min-width"] = (parseFloat(w) - 0) + 'px';
        hel[i].style["max-width"] = (parseFloat(w) - 0) + 'px';
      }
    }
    frozenDiv.appendChild(nt);
    if (hasAuto) {
      console.log("adjustHeader delay");
      frozenDiv.removeChild(nt);
      var self = this;
      if (invokes != -1) {

        setTimeout(function () {
          // var clrect = c.getBoundingClientRect(); 
          // c.style.height = (window.innerHeight - clrect.top - 10) + 'px';
          self.adjustHeader(c, invokes + 1);
        }, 1000);
      }
    }
  }

  componentDidMount() {
    var c = this.gridRef.current;
    var self = this;
    c.addEventListener('scroll', function () {
      self.adjustHeader(c);
      var nt = c.querySelectorAll(".frozen-grid-header")[0];
      if (nt) {
        //console.log('scroll', c.scrollLeft, c.scrollTop);
        nt.style.top = c.scrollTop + 'px';
      }
    });

    if (self.props.stretchTo) {
      var sTo = document.querySelectorAll(self.props.stretchTo)[0];
      var sToRect = sTo.getBoundingClientRect();
      var clrect = c.getBoundingClientRect();
      var smargin = 1;
      if (self.props.stretchMargin) {
        smargin = parseInt(self.props.stretchMargin);
      }
      c.style.height = (sToRect.top - clrect.top - smargin) + 'px';
    }

    window.addEventListener('resize', function () {
      //console.log('window resize detected');
      if (self.props.stretchTo) {
        var sTo = document.querySelectorAll(self.props.stretchTo)[0];
        var sToRect = sTo.getBoundingClientRect();
        var clrect = c.getBoundingClientRect();
        var smargin = 1;
        if (self.props.stretchMargin) {
          smargin = parseInt(self.props.stretchMargin);
        }
        c.style.height = (sToRect.top - clrect.top - smargin) + 'px';
      }
      setTimeout(function () {
        self.adjustHeader(c, -1);
      }, 330);
    });
  }

  handleFilterChange(event) {
    this.setState({
      filterStr: event.target.value,
      doUpdate: true
    }
    );

    //this.props.doUpdate = true 
  }




  /**
   * 
   * @param row (object): Table row data
   * row: {
   * parentRowData: []
   * header: [],
   * data: []
   * 
   * }
   */
  generateChildRow(row, tbody, colOpts, item_subitem, headerObject, orderObject) {
    const rowArr = (row instanceof Array) ? row : [row]
    const rowData = [];
    rowArr.forEach(row => {
    row.parentRowData.map((rowItem, i) => {
      if (i === 0) {
        // if first cell then add 'chevron' icon 
        rowData.push(<td className="toggle-anchor"
          onClick={this.rowToggleHandler}
        >
          <i style={{ "color": "#0096d6", "fontSize": "10px" }} className="glyphicon glyphicon-chevron-up" /> &nbsp; {rowItem}
        </td>)
      } else {
        rowData.push(<td>{rowItem}</td>)
      }
      return rowItem;
    })
    // push data of parent row 
    tbody.push(<tr className={"toggle-header-row " + ("ncols-" + row.parentRowData.length)}>{rowData}</tr>);

    const tbodyInner = [];
    // frame header of inner tbody
    if (row.header) {
      const innerHeaderRowData = [];
      row.header.map((rowItem, i) => {
        if (typeof rowItem.name === 'string')
          innerHeaderRowData.push(<th className="inner-th" >{rowItem.name}</th>)
        else
          innerHeaderRowData.push(<th className="inner-th" ><DDLabel field={rowItem.name} /></th>)
        return rowItem;
      })
      tbodyInner.push(<tr className={("ncols-" + innerHeaderRowData.length)}>{innerHeaderRowData}</tr>)
    }
    if (row.data) {
      row.data.map((innerRow, i) => {
        if (innerRow instanceof Array) {
          tbodyInner.push(<tr className={"level-" + i}>{SimpleDataGrid_formatRow(false, false, 0, 0, colOpts, innerRow, item_subitem, headerObject, orderObject)}</tr>);
        } else if (innerRow.parentRowData !== undefined) {
          this.generateChildRow(innerRow, tbodyInner, colOpts, item_subitem, headerObject, orderObject);
        }
      })
    }

    tbody.push(<tr>
      <td colSpan={row.parentRowData.length}>
        <div className="inner-table-wrraper"><table className="table-inner"><tbody className="tbody-inner">{tbodyInner}</tbody></table></div>
      </td>
    </tr>)

  })
  }

  render() {

    var item_subitem = this.props.item_subitem;
    var headerObject = this.props.header;
    var orderObject = this.props.order;

    var id = ''

    if (this.props.id) {
      id = this.props.id;
    }

    var colOpts = [];
    var header = this.props.header.map(function (col, i) {

      if (typeof col == 'string') {
        colOpts.push({ "whiteSpace": "nowrap" });
        return (<th>{col}</th>)
      } else {
        var opt = {};
        if (col.ellipsis) {
          opt['overflow'] = 'hidden';
          opt['text-overflow'] = 'ellipsis';
        }
        if (col.width) {
          opt['maxWidth'] = col.width;
          opt['width'] = col.width;
        }
        if (col.right) { opt['textAlign'] = 'right'; }
        if (1 || col.nowrap) { opt['whiteSpace'] = 'nowrap'; }
        colOpts.push(opt);

        if (typeof col.name === 'string')
          return (<th>{col.name}</th>)
        else
          return (<th><DDLabel field={col.name} /></th>)
      }
    });

    var filterDiv = null;

    if (this.props.filter) {
      filterDiv =
        <div style={{ "textAlign": "right", "backgroundColor": "#f0f0f0", "color": "#777", "padding": "5px" }} >
          filter: <input type="text" value={this.state.filterStr}
            onChange={this.handleFilterChange} size="40" />
        </div>

    }
    var filterStr = this.state.filterStr.toLowerCase();

    var tbody = [];
    for (var i = 0; i < this.props.data.length; i++) {
      var row = this.props.data[i];

      var rowColor = '#ffffff'

      if (row instanceof Array && row.length > 0 && !row[0].parentRowData) {
        tbody.push(<tr>{SimpleDataGrid_formatRow(false, false, 0, 0, colOpts, row, item_subitem, headerObject, orderObject)}</tr>);

      } else if (row.parentRowData !== undefined || (row[0] && row[0].parentRowData !== undefined) ) {
        this.generateChildRow(row, tbody, colOpts, item_subitem, headerObject, orderObject);
      }
    }

    var exportDiv = null;

    if (this.props.exportexcelreq) {
      exportDiv = <ExportExcel exportexcelreq={this.props.exportexcelreq} />;
    }

    var specialStyle = {};
    if (this.props.width) {
      specialStyle.width = this.props.width;
    }

    var outerStyle = {
      position: "relative",
      width: "100%",
      padding: "0px",
      margin: "0px",
      border: "1px solid #ccc",
      overflow: "auto",
      scroll: "auto"
    }
    var frozenStyle = {
      backgroundColor: "#ffffff",
      position: "absolute",
      padding: "0px",
      margin: "0px",
      width: "100%",
      zIndex: "100"
    }

    if (this.props.height && this.props.height > 0) {
      outerStyle.height = this.props.height;
    }

    var actions = this.props.actions;


    var actionBar = null;

    if (this.props.enableDownload || actions != undefined) {

      var actionMenu = null;

      if (actions && actions.label && actions.menu && actions.menu.length > 0) {
        actionMenu =
          <div className="btn-group navbar-right" style={{ margin: "0px 5px" }}>
            <button type="button" className="btn btn-primary btn-sm dropdown-toggle"
              style={{ padding: "0px 5px", "lineHeight": "16px", "fontSize": "13px" }}
              data-toggle="dropdown"
            >
              {actions.label}
                &nbsp;
                <i className="glyphicon glyphicon-circle-arrow-down"></i>
            </button>
            <ul className="dropdown-menu" role="menu">
              {actions.menu.map(function (m, i) {

                return <li key={i}><a style={{ cursor: "pointer" }} href={m.href} >{m.label}</a></li>
              })
              }
            </ul>
          </div>

      }

      if (actions && actions.label && actions.action) {
        actionMenu =
          <span>
            {actions.label}
             &nbsp;
             <i className="glyphicon glyphicon-circle-arrow-down" onClick={actions.action} ></i>
          </span>

      }
      if (actions && actions.label && actions.href) {
        if (actions.target) {
          actionMenu =
            <span>
              {actions.label}
               &nbsp;
               <a href={actions.href} target={actions.target} style={{ color: "#fff" }}><i className="glyphicon glyphicon-circle-arrow-down"></i></a>
            </span>
        } else {
          actionMenu =
            <span>
              {actions.label}
               &nbsp;
               <a href={actions.href} style={{ color: "#fff" }}><i className="glyphicon glyphicon-circle-arrow-down"></i></a>
            </span>
        }
      }

      actionBar =
        <div style={{ "backgroundColor": "#0096d6", color: "#fff", padding: "4px 5px 2px", "fontSize": "12px" }}>
          <i className="glyphicon glyphicon-circle-arrow-down"
            title="download grid as shown"
            onClick={this.handleDowloadAsShown}
            style={{ "color": "#fff", "fontSize": "13px", marginRight: "8px" }}
          />
          {this.props.leftLabel}
          <span style={{ float: "right" }}>
            {actionMenu}
          </span>
        </div>
    }


    if (this.gridRef && this.gridRef.current) {
      var gridRefCurrent = this.gridRef.current;
      var self = this;
      setTimeout(function () {
        self.adjustHeader(gridRefCurrent, -1);
      }, 330);
    }

    return (

      <div id={id} className="nested-data-grid simpleDataGridWrapper">
        {exportDiv}
        {filterDiv}
        {actionBar}
        <div className="nestedgrid-content" ref={this.gridRef} style={outerStyle}>
          <div className="frozen-grid-header" style={frozenStyle}></div>
          <table id={id + '_table'} className="grid-container-table table table-hover" style={specialStyle}>
            <thead>
              <tr>{header}</tr>
            </thead>
            <tbody>
              {tbody}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

}